import React, { useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import { Colors } from "src/assets/colors/Colors";
import InputForm from "src/components/ComponentesFormularios/InputForm";
import { GlobalConstants } from "src/data/GlobalConstants";
import ImagePickerCrop from "src/components/ImagePickerCrop";
import { classResponsiveFormWidthHeader, optionsYesNoResponse } from "src/data/ConstantForm";
import SelectFormVirtualize from "src/components/ComponentesFormularios/SelectFormVirtualize";
import { categoriasService } from "src/services/unoauno/apiCategorias";
import { modalCRUDService } from "src/services/modalCRUDService";
import { getCurrentTime, toBlob } from "src/util/functions";

const FormCRUDCategorias = ({ properties }) => {
    const { data: { 
        proveedor,
        edit, 
        reload,
        categoria
    }} = properties;

    const dispatch = useDispatch();

    const [urlImagen, setUrlImagen] = useState(edit ? categoria?.urlImagen ?? "" : "");
    const previewRef = useRef(null);

    const methods = useForm({defaultValues: {
        nombreCategoria: edit ? categoria?.nombre : "",
        orden: edit ? categoria?.orden : "",
        evento: edit ? categoria?.evento : "",
        color: edit ? categoria?.color : Colors.WHITE,
    }});

    const { control, handleSubmit, formState: { errors } } = methods;

    const onClickGuardar = async (datos) => {
        let idCategoria = categoria?.idCategoria;
        datos.orden ||= "0";
        datos.evento = datos.evento.id
        datos.color = datos.color == Colors.WHITE ? "" : datos.color;
        
        try {
            if(edit) {
                await categoriasService.updateCategoria({ ...datos, idCategoria: categoria?.idCategoria });
            }else {
                const response = await categoriasService.saveCategoria({ ...datos, idProveedor: proveedor.id });
                idCategoria = response.data;
            }

            if(previewRef?.current) {
                const nombreImg = `cat_${idCategoria}_${getCurrentTime()}.png`

                const blobImg = await toBlob(previewRef.current);
                const file = new File([blobImg], nombreImg);

                await categoriasService.saveImagen({file: file, idCat: idCategoria, nombreImg, extension: "/categorias"})
            }
            
            reload();
            modalCRUDService.clear();

            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Solicitud exitosa' } });
        } catch (error) {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: "Ya existe una marca con el mismo nombre" } });
        }
    }

    return (
        <FormProvider {...methods}>
            <div className="px-2">
                <Tooltip className="m-0" title="Guardar" aria-label="Guardar" style={{position: "absolute", right: "3.5%"}}>
                    <a onClick={handleSubmit(onClickGuardar, () => {})} className="icon-container-actions d-flex">
                        <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                        <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
                    </a>
                </Tooltip>

                <strong style={{fontSize: "13pt"}}>Datos básicos:</strong>
                
                <div className="container w-100 mx-0 px-0 mt-2">
                    <InputForm
                        inputProps={{ control }}
                        identificador="nombreCategoria" 
                        label="Nombre de la Categoría"
                        placeholder=""
                        required={true}
                        textUppercase={false}
                        className="px-2 col-6"
                        customError={errors.nombreCategoria ? "El campo no puede estar vacío" : null} rules={{ maxLength: 200}}
                        style={errors.nombreCategoria ? { marginBottom: 0 } : ''}
                    />

                    <InputForm
                        inputProps={{ control }}
                        identificador="orden" 
                        label="Orden"
                        placeholder=""
                        type="number"
                        required={false}
                        textUppercase={false}
                        className="px-2 col-2"
                    />

                    <InputForm
                        inputProps={{ control }}
                        identificador="color" 
                        label="Color"
                        placeholder=""
                        type="color"
                        required={false}
                        textUppercase={false}
                        style={{paddingRight: "0px"}}
                        className="px-2 col-2"
                    />
                </div>

                <div className="container w-100 mx-0 px-0 mt-2">
                    <SelectFormVirtualize
                        isMulti={false} 
                        inputProps={{ control }} 
                        disabled={false} 
                        showId={false} 
                        identificador="evento" 
                        label="Es de Evento"
                        options={optionsYesNoResponse} 
                        required={true} 
                        className={`${classResponsiveFormWidthHeader}`}
                        customError={errors.evento ? "El campo no puede estar vacío" : null} rules={{ minLength: 0 }}
                    />
                </div>

                <div className="container w-100 mx-0 px-0 mt-3">
                    <strong style={{fontSize: "13pt"}}>Imagen de la categoría:</strong>
                    <div className="px-3 mt-1">
                        <ImagePickerCrop urlImagen={urlImagen} previewRef={previewRef}/>
                    </div>
                </div>
            </div>
        </FormProvider>
    )
}

export default FormCRUDCategorias;